import { GenericResponse } from "./genericResponse.model";
import { User } from "./user.model";


export class checkList {
  MediaId: number;
  InventionId: string;
  ContractSessionId: string;
  DocumentTypeID: string;
  FileName: string;
  Media: string;
}

export interface CheckListImagesResponse extends GenericResponse {
  listImages: checkList[];
  currentUser: User;
  lastAdded: number;
}

export class configCheckList {
  MediaId: number;
  FileName: string;
  Media: string;
}

export interface ConfigCheckListImagesResponse extends GenericResponse {
  listConfigImages: configCheckList[];
  currentUser: User;
  lastAdded: number;
}

